var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategyBoard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1018",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-svgjs": "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1019"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1020"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.8 4.2H4.2c-1.1 0-2 .9-2 2s.9 2 2 2h55.7c1.1 0 2-.9 2-2-.1-1.1-1-2-2.1-2zM5.5 43.8c0 1.2 1 2.3 2.3 2.3h22l-.2.3-10.5 15.1c-.5.7-.3 1.7.4 2.2.3.2.6.3.9.3.5 0 1-.3 1.3-.7l8.7-12.5v8.7c0 .9.7 1.6 1.6 1.6.9 0 1.6-.7 1.6-1.6v-8.7l8.7 12.5c.3.4.8.7 1.3.7.3 0 .6-.1.9-.3.7-.5.9-1.5.4-2.2L34.4 46.4l-.2-.3h22c1.2 0 2.3-1 2.3-2.3V9.6h-53v34.2zm39.7-9.5c2 0 3.6 1.6 3.6 3.6s-1.6 3.6-3.6 3.6-3.6-1.6-3.6-3.6c.1-2 1.7-3.6 3.6-3.6zM32.9 15.5c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.4.1.5.2l2.4 2.4 2.4-2.4c.1-.1.3-.2.5-.2s.4.1.5.2c.1.1.2.3.2.5s-.1.4-.2.5l-2.4 2.4 2.4 2.4c.1.1.2.3.2.5s-.1.4-.2.5c-.1.1-.3.2-.5.2s-.4-.1-.5-.2l-2.4-2.4-2.4 2.4c-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5l2.4-2.4-2.4-2.4zm-16.3 1.4c.1-.2.2-.3.3-.4.1-.1.2-.1.3-.1.3 0 .5.1.6.4.6 1 6 10.2 17.7 15.8l.7.4-1.3-2.8c-.2-.4 0-.8.4-.9.1 0 .2-.1.3-.1.3 0 .5.2.6.4l2 4.5v.4l-.1.1v.1s0 .1-.1.1c-.1.1-.2.2-.4.3l-4.5 1.7h-.2c-.3 0-.6-.2-.7-.5-.1-.4 0-.8.4-.9l2.9-1.1-.7-.3c-12.4-5.8-17.9-15.4-18.5-16.5.3-.2.3-.4.3-.6zm-1.2 16c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.4.1.5.2l2.4 2.4 2.4-2.4c.1-.1.3-.2.5-.2s.4.1.5.2c.1.1.2.3.2.5s-.1.4-.2.5l-2.4 2.4 2.4 2.4c.1.1.2.3.2.5s-.1.4-.2.5c-.1.1-.3.2-.5.2s-.4-.1-.5-.2l-2.4-2.4-2.4 2.4c-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5l2.4-2.4-2.4-2.4zM34.5 2.5C34.3 1.1 33.3 0 32 0s-2.3 1.1-2.5 2.5v.3h5v-.3z",
    fill: "#ffffff",
    className: "color000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2 40c1.2 0 2.2-1 2.2-2.2 0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2.1 1.3 1 2.2 2.2 2.2z",
    fill: "#ffffff",
    className: "color000 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyBoard);
export default __webpack_public_path__ + "static/media/strategyBoard.8f2470c11205b704bc6ed5d2868a4323.svg";
export { ForwardRef as ReactComponent };